// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg viewBox=%270 0 256 256%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cfilter id=%27noise%27%3E%3CfeTurbulence type=%27fractalNoise%27 baseFrequency=%270.9%27 numOctaves=%274%27 stitchTiles=%27stitch%27/%3E%3C/filter%3E%3Crect width=%27100%25%27 height=%27100%25%27 filter=%27url%28%23noise%29%27 opacity=%270.02%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Markhor Systems - Modern Black & White Design System */

/* Import Premium Fonts */

/* CSS Custom Properties for Midnight Blue Theme */
:root {
  /* Primary Colors - Midnight Blue Theme */
  --primary-black: #100D25;
  --primary-white: #FFFFFF;
  --pure-black: #0a0815;
  --off-white: #f8f9ff;

  /* Blue Scale */
  --blue-50: #eff6ff;
  --blue-100: #dbeafe;
  --blue-200: #bfdbfe;
  --blue-300: #93c5fd;
  --blue-400: #60a5fa;
  --blue-500: #3b82f6;
  --blue-600: #2563eb;
  --blue-700: #1d4ed8;
  --blue-800: #1e40af;
  --blue-900: #1e3a8a;
  --blue-950: #172554;

  /* Gray Scale (Blue-tinted) */
  --gray-50: #f8fafc;
  --gray-100: #f1f5f9;
  --gray-200: #e2e8f0;
  --gray-300: #cbd5e1;
  --gray-400: #94a3b8;
  --gray-500: #64748b;
  --gray-600: #475569;
  --gray-700: #334155;
  --gray-800: #1e293b;
  --gray-900: #0f172a;
  --gray-950: #020617;

  /* Midnight Blue Theme Colors */
  --navy-darkest: #0a0815;
  --navy-darker: #100D25;
  --navy-dark: #16122f;
  --navy-medium: #1e1a3a;
  --navy-light: #252145;

  /* Accent Colors - Purple Variations */
  --accent-light: #ede9fe;
  --accent-dark: #5b21b6;
  --accent-hover: #7c3aed;
  --accent-primary: #8b5cf6;
  --accent-glow: #a78bfa;

  /* Background Gradients */
  --bg-dark: linear-gradient(180deg, #100D25 0%, #16122f 50%, #1e1a3a 100%);
  --bg-light: linear-gradient(180deg, #FFFFFF 0%, #f8f9ff 50%, #e8ebff 100%);
  --bg-gradient-subtle: linear-gradient(135deg, #100D25 0%, #16122f 50%, #1e1a3a 100%);
  --bg-gradient-hero: linear-gradient(135deg, #100D25 0%, #1e1a3a 50%, #16122f 100%);
  --bg-accent: linear-gradient(135deg, #FFFFFF 0%, #f0f0f0 50%, #e0e0e0 100%);
  --bg-secondary: #16122f;
  --bg-noise: url(${___CSS_LOADER_URL_REPLACEMENT_0___});

  /* Glass Effects */
  --glass-bg: rgba(16, 13, 37, 0.95);
  --glass-bg-dark: rgba(16, 13, 37, 0.98);
  --glass-bg-light: rgba(255, 255, 255, 0.98);
  --glass-border: rgba(255, 255, 255, 0.15);
  --glass-border-dark: rgba(255, 255, 255, 0.2);
  --glass-border-light: rgba(255, 255, 255, 0.08);

  /* Primary Theme Colors */
  --primary-100: #ede9fe;
  --primary-200: #ddd6fe;
  --primary-300: #c4b5fd;
  --primary-400: #a78bfa;
  --primary-500: #8b5cf6;
  --primary-600: #7c3aed;
  
  /* Typography */
  --font-display: 'Montserrat', sans-serif;
  --font-heading: 'Montserrat', sans-serif;
  --font-body: 'Montserrat', sans-serif;
  
  /* Font Sizes */
  --text-xs: 0.75rem;
  --text-sm: 0.875rem;
  --text-base: 1rem;
  --text-lg: 1.125rem;
  --text-xl: 1.25rem;
  --text-2xl: 1.5rem;
  --text-3xl: 1.875rem;
  --text-4xl: 2.25rem;
  --text-5xl: 3rem;
  --text-6xl: 3.75rem;
  --text-7xl: 4.5rem;
  --text-8xl: 6rem;
  
  /* Spacing */
  --space-1: 0.25rem;
  --space-2: 0.5rem;
  --space-3: 0.75rem;
  --space-4: 1rem;
  --space-5: 1.25rem;
  --space-6: 1.5rem;
  --space-8: 2rem;
  --space-10: 2.5rem;
  --space-12: 3rem;
  --space-16: 4rem;
  --space-20: 5rem;
  --space-24: 6rem;
  --space-32: 8rem;
  
  /* Border Radius */
  --radius-sm: 0.25rem;
  --radius-md: 0.5rem;
  --radius-lg: 0.75rem;
  --radius-xl: 1rem;
  --radius-2xl: 1.5rem;
  --radius-3xl: 2rem;
  --radius-full: 9999px;
  
  /* Shadows */
  --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  --shadow-xl: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
  --shadow-2xl: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  --shadow-glow: 0 0 60px rgba(255, 255, 255, 0.1);
  
  /* Transitions */
  --transition-fast: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  --transition-normal: 300ms cubic-bezier(0.4, 0, 0.2, 1);
  --transition-slow: 500ms cubic-bezier(0.4, 0, 0.2, 1);
  --transition-bounce: 500ms cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

/* App Layout */
.App {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: var(--primary-white);
  position: relative;
  overflow-x: hidden;
}

/* Typography Classes */
.heading-hero {
  font-family: var(--font-display);
  font-size: clamp(2.5rem, 8vw, var(--text-7xl));
  font-weight: 800;
  line-height: 1.05;
  letter-spacing: -0.03em;
}

.heading-page {
  font-family: var(--font-display);
  font-size: clamp(2rem, 5vw, var(--text-5xl));
  font-weight: 700;
  line-height: 1.1;
  letter-spacing: -0.02em;
}

.heading-section {
  font-family: var(--font-heading);
  font-size: clamp(1.5rem, 4vw, var(--text-4xl));
  font-weight: 600;
  line-height: 1.2;
  letter-spacing: -0.01em;
}

.heading-subsection {
  font-family: var(--font-heading);
  font-size: clamp(1.25rem, 3vw, var(--text-2xl));
  font-weight: 600;
  line-height: 1.3;
}

.text-body {
  font-family: var(--font-body);
  font-size: var(--text-base);
  font-weight: 400;
  line-height: 1.7;
}

.text-large {
  font-family: var(--font-body);
  font-size: var(--text-lg);
  font-weight: 400;
  line-height: 1.7;
}

/* Button System */
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  padding: var(--space-4) var(--space-8);
  border-radius: var(--radius-full);
  font-family: var(--font-heading);
  font-weight: 500;
  font-size: var(--text-sm);
  text-decoration: none;
  border: none;
  cursor: pointer;
  transition: all var(--transition-normal);
  position: relative;
  overflow: hidden;
}

.btn-primary {
  background: var(--primary-white);
  color: var(--primary-black);
  border: 2px solid var(--primary-white);
}

.btn-primary:hover {
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 10px 40px rgba(255, 255, 255, 0.3);
}

.btn-secondary {
  background: transparent;
  color: var(--primary-white);
  border: 2px solid var(--primary-white);
}

.btn-secondary:hover {
  background: var(--primary-white);
  color: var(--primary-black);
  border-color: var(--primary-white);
}

.btn-white {
  background: var(--primary-white);
  color: var(--primary-black);
  border: 2px solid var(--primary-white);
}

.btn-white:hover {
  background: rgba(255, 255, 255, 0.9);
  color: var(--primary-black);
  border-color: var(--primary-white);
}

.btn-ghost {
  background: transparent;
  color: var(--primary-white);
  border: 2px solid rgba(255, 255, 255, 0.3);
}

.btn-ghost:hover {
  border-color: var(--primary-white);
  background: rgba(255, 255, 255, 0.1);
}

/* Card System */
.card {
  background: var(--primary-white);
  border: 1px solid rgba(16, 13, 37, 0.1);
  border-radius: var(--radius-2xl);
  padding: var(--space-8);
  transition: all var(--transition-normal);
}

.card:hover {
  border-color: rgba(16, 13, 37, 0.2);
  box-shadow: 0 20px 40px rgba(16, 13, 37, 0.15);
}

.card-dark {
  background: rgba(16, 13, 37, 0.95);
  border: 1px solid rgba(255, 255, 255, 0.15);
}

.card-dark:hover {
  border-color: rgba(255, 255, 255, 0.3);
}

/* Section Backgrounds */
.section-dark {
  background: #100D25;
  color: var(--primary-white);
}

.section-light {
  background: var(--primary-white);
  color: #100D25;
}

.section-gray {
  background: #f8f9ff;
  color: #100D25;
}

/* Grid System */
.grid {
  display: grid;
  gap: var(--space-8);
}

.grid-2 {
  grid-template-columns: repeat(2, 1fr);
}

.grid-3 {
  grid-template-columns: repeat(3, 1fr);
}

.grid-4 {
  grid-template-columns: repeat(4, 1fr);
}

@media (max-width: 1024px) {
  .grid-4 {
    grid-template-columns: repeat(2, 1fr);
  }
  .grid-3 {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .grid-2,
  .grid-3,
  .grid-4 {
    grid-template-columns: 1fr;
  }
}

/* Container */
.container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 var(--space-6);
  width: 100%;
}

/* Animation Classes */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes float {
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-20px); }
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.animate-fadeInUp {
  animation: fadeInUp 0.8s ease-out forwards;
}

.animate-fadeIn {
  animation: fadeIn 0.6s ease-out forwards;
}

.animate-slideIn {
  animation: slideIn 0.6s ease-out forwards;
}

.animate-float {
  animation: float 6s ease-in-out infinite;
}

/* Staggered Animations */
.stagger-1 { animation-delay: 0.1s; }
.stagger-2 { animation-delay: 0.2s; }
.stagger-3 { animation-delay: 0.3s; }
.stagger-4 { animation-delay: 0.4s; }
.stagger-5 { animation-delay: 0.5s; }

/* Loading States */
.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: var(--space-12);
}

.loading::after {
  content: '';
  width: 40px;
  height: 40px;
  border: 3px solid rgba(255, 255, 255, 0.2);
  border-top: 3px solid var(--primary-white);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

/* Utilities */
.text-center { text-align: center; }
.text-left { text-align: left; }
.text-right { text-align: right; }

.text-white { color: var(--primary-white); }
.text-black { color: #100D25; }
.text-gray { color: var(--gray-500); }
.text-blue { color: var(--primary-white); }

.bg-black { background: #100D25; }
.bg-white { background: var(--primary-white); }
.bg-gray { background: #f8f9ff; }
.bg-navy { background: #16122f; }

/* Noise Texture Overlay */
.noise-overlay::after {
  content: '';
  position: absolute;
  inset: 0;
  background-image: var(--bg-noise);
  opacity: 0.4;
  pointer-events: none;
}

/* Gradient Text */
.gradient-text {
  background: linear-gradient(135deg, #FFFFFF 0%, #cccccc 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.gradient-text-white {
  background: linear-gradient(135deg, #FFFFFF 0%, #e0e0e0 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* Scrollbar Styling */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: #16122f;
}

::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.4);
  border-radius: var(--radius-full);
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.6);
}

/* Selection */
::selection {
  background: var(--primary-white);
  color: var(--primary-black);
}

/* Focus States */
*:focus {
  outline: 2px solid var(--primary-white);
  outline-offset: 2px;
}

*:focus:not(:focus-visible) {
  outline: none;
}

/* Responsive Typography */
@media (max-width: 768px) {
  .heading-hero {
    font-size: clamp(2rem, 10vw, 3rem);
  }
  
  .heading-page {
    font-size: clamp(1.75rem, 6vw, 2.5rem);
  }
  
  .heading-section {
    font-size: clamp(1.25rem, 5vw, 2rem);
  }
}

/* Smooth Page Transitions */
main {
  flex: 1 1;
}

/* ═══════════════════════════════════════════
   PAGE TRANSITIONS — Motion (AnimatePresence) driven
   ═══════════════════════════════════════════ */

/* Suspense fallback — subtle shimmer instead of blank flash.
   Ideally this never shows because all routes are preloaded,
   but it's here as a graceful fallback on the very first visit. */
.page-loading {
  min-height: 70vh;
  background:
    linear-gradient(90deg,
      transparent 0%,
      rgba(170,140,255,0.06) 50%,
      transparent 100%);
  background-size: 200% 100%;
  animation: pageLoadingShimmer 1.4s ease-in-out infinite;
}
@keyframes pageLoadingShimmer {
  0%, 100% { background-position: 200% 0%; }
  50%      { background-position: -200% 0%; }
}

/* The wrapper applied to each motion.div page.
   We only set GPU hints — Motion controls the actual transform/opacity
   via inline styles, so no CSS transitions here (would conflict). */
.page-motion {
  min-height: 70vh;
  transform-origin: center top;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  /* Trick the browser into compositing this on its own GPU layer */
  transform: translate3d(0, 0, 0);
}

/* Top route-change progress bar */
.route-progress {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  z-index: 100;
  pointer-events: none;
  overflow: hidden;
}
.route-progress::after {
  content: '';
  position: absolute;
  top: 0;
  left: -35%;
  width: 35%;
  height: 100%;
  background: linear-gradient(90deg,
    transparent,
    rgba(170,140,255,0.3) 20%,
    #a98fff 45%,
    #ffffff 50%,
    #a98fff 55%,
    rgba(170,140,255,0.3) 80%,
    transparent);
  box-shadow:
    0 0 10px rgba(170,140,255,0.8),
    0 0 20px rgba(170,140,255,0.4);
  animation: routeProgressSlide 0.95s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}
@keyframes routeProgressSlide {
  0%   { left: -35%; }
  100% { left: 100%; }
}

/* Push progress bar below announcement bar when visible */
body.has-announcement .route-progress { top: 42px; }
@media (max-width: 640px) {
  body.has-announcement .route-progress { top: 40px; }
}

/* Reduced motion — Motion respects prefers-reduced-motion internally,
   but we still remove the progress-bar slide animation */
@media (prefers-reduced-motion: reduce) {
  .route-progress::after { animation: none; opacity: 0.4; }
}

/* ═══════════════════════════════════════════
   VIEW TRANSITIONS API (native browser layer)
   When the browser supports it (Chrome/Edge/Safari TP, 85% coverage
   in 2025), react-router-dom v7's viewTransition prop triggers
   document.startViewTransition() — the browser snapshots the old
   and new DOM and cross-fades them on the compositor thread.
   ═══════════════════════════════════════════ */

/* Root view transition — let our Motion animations drive, but keep
   a graceful fallback duration if the browser fires the transition
   before Motion takes over. */
::view-transition-old(root),
::view-transition-new(root) {
  animation-duration: 260ms;
  animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);
}
::view-transition-old(root) {
  animation-name: vtFadeOut;
}
::view-transition-new(root) {
  animation-name: vtFadeIn;
}
@keyframes vtFadeOut {
  from { opacity: 1; }
  to   { opacity: 0; }
}
@keyframes vtFadeIn {
  from { opacity: 0; }
  to   { opacity: 1; }
}

/* Keep the fixed chrome (header, announcement bar, floating button,
   scroll-top) stable during the native cross-fade so they don't double-paint */
header.fixed,
.announcement-bar,
.floating-contact,
.floating-scroll-top,
.route-progress {
  view-transition-name: none;
}

/* ======================================
   LOADING SCREEN STYLES
   ====================================== */

.loading-screen {
  position: fixed;
  inset: 0;
  background: linear-gradient(135deg, #100D25 0%, #16122f 50%, #1e1a3a 100%);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.loading-screen.exit {
  animation: loadingExit 0.6s ease-out forwards;
}

@keyframes loadingExit {
  0% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform: scale(1.1);
  }
}

.loading-content {
  text-align: center;
  z-index: 2;
}

.loading-logo {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin-bottom: 48px;
  animation: logoEnter 0.8s ease-out both;
}

@keyframes logoEnter {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.loading-logo-img {
  width: 120px;
  height: 120px;
  position: relative;
  animation: logoPulse 2s ease-in-out infinite;
  filter: drop-shadow(0 0 30px rgba(129, 140, 248, 0.4));
}

@keyframes logoPulse {
  0%, 100% {
    opacity: 1;
    filter: drop-shadow(0 0 30px rgba(129, 140, 248, 0.4));
  }
  50% {
    opacity: 0.75;
    filter: drop-shadow(0 0 50px rgba(167, 139, 250, 0.6));
  }
}

.logo-text {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.logo-name {
  font-family: 'Montserrat', sans-serif;
  font-size: 32px;
  font-weight: 700;
  color: white;
  letter-spacing: 0.1em;
}

.logo-tagline {
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
  letter-spacing: 0.3em;
  text-transform: uppercase;
  margin-top: 4px;
}

.loading-progress {
  width: 200px;
  height: 2px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  overflow: hidden;
  margin: 0 auto;
}

.progress-bar {
  height: 100%;
  background: linear-gradient(90deg, var(--primary-white) 0%, rgba(255, 255, 255, 0.8) 100%);
  border-radius: 4px;
  transition: width 0.1s linear;
}

.loading-percentage {
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.4);
  margin-top: 16px;
  letter-spacing: 0.2em;
}

/* Loading Background Elements */
.loading-bg-elements {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.bg-element {
  position: absolute;
  border: 1px solid rgba(255, 255, 255, 0.05);
}

.bg-element-1 {
  width: 400px;
  height: 400px;
  top: -100px;
  left: -100px;
  border-radius: 50%;
  animation: bgFloat 10s ease-in-out infinite;
}

.bg-element-2 {
  width: 300px;
  height: 300px;
  bottom: -50px;
  right: -50px;
  transform: rotate(45deg);
  animation: bgFloat 12s ease-in-out infinite reverse;
}

.bg-element-3 {
  width: 200px;
  height: 200px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(45deg);
  animation: bgPulse 4s ease-in-out infinite;
}

@keyframes bgFloat {
  0%, 100% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(30px, -30px);
  }
}

@keyframes bgPulse {
  0%, 100% {
    opacity: 0.1;
    transform: translate(-50%, -50%) rotate(45deg) scale(1);
  }
  50% {
    opacity: 0.05;
    transform: translate(-50%, -50%) rotate(45deg) scale(1.2);
  }
}

/* ======================================
   MARQUEE STYLES
   ====================================== */

.marquee-container {
  width: 100%;
  overflow: hidden;
  position: relative;
}

.marquee-container::before,
.marquee-container::after {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100px;
  z-index: 2;
  pointer-events: none;
}

.marquee-container::before {
  left: 0;
  background: linear-gradient(90deg, #16122f 0%, transparent 100%);
}

.marquee-container::after {
  right: 0;
  background: linear-gradient(90deg, transparent 0%, #16122f 100%);
}

.marquee-track {
  display: flex;
  align-items: center;
  animation: marquee 30s linear infinite;
  width: max-content;
}

.marquee-track:hover {
  animation-play-state: paused;
}

.marquee-item {
  transition: color 0.3s ease;
}

.marquee-item:hover {
  color: var(--primary-white);
}

@keyframes marquee {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

/* ======================================
   CRAZY ANIMATION EFFECTS
   ====================================== */

/* Gradient Text Animation */
@keyframes gradient-x {
  0%, 100% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
}

.animate-gradient-x {
  background-size: 200% 200%;
  animation: gradient-x 3s ease infinite;
}

/* Glow Pulse Effect */
@keyframes glowPulse {
  0%, 100% {
    box-shadow: 0 0 20px rgba(255, 255, 255, 0.1);
  }
  50% {
    box-shadow: 0 0 40px rgba(255, 255, 255, 0.3), 0 0 60px rgba(255, 255, 255, 0.1);
  }
}

.glow-pulse {
  animation: glowPulse 2s ease-in-out infinite;
}

/* Text Shimmer Effect */
@keyframes shimmer {
  0% {
    background-position: -200% center;
  }
  100% {
    background-position: 200% center;
  }
}

.text-shimmer {
  background: linear-gradient(
    90deg,
    rgba(255,255,255,0) 0%,
    rgba(255,255,255,0.5) 50%,
    rgba(255,255,255,0) 100%
  );
  background-size: 200% 100%;
  animation: shimmer 3s ease-in-out infinite;
  -webkit-background-clip: text;
  background-clip: text;
}

/* Morphing Shape Animation */
@keyframes morph {
  0%, 100% {
    border-radius: 60% 40% 30% 70% / 60% 30% 70% 40%;
  }
  25% {
    border-radius: 30% 60% 70% 40% / 50% 60% 30% 60%;
  }
  50% {
    border-radius: 50% 60% 30% 60% / 30% 60% 70% 40%;
  }
  75% {
    border-radius: 60% 40% 60% 30% / 70% 30% 50% 60%;
  }
}

.morph-shape {
  animation: morph 8s ease-in-out infinite;
}

/* 3D Rotation */
@keyframes rotate3d {
  0% {
    transform: perspective(1000px) rotateY(0deg);
  }
  100% {
    transform: perspective(1000px) rotateY(360deg);
  }
}

.rotate-3d {
  animation: rotate3d 20s linear infinite;
}

/* Elastic Bounce */
@keyframes elasticBounce {
  0%, 100% {
    transform: translateY(0);
  }
  30% {
    transform: translateY(-30px);
  }
  50% {
    transform: translateY(-15px);
  }
  65% {
    transform: translateY(-25px);
  }
  80% {
    transform: translateY(-10px);
  }
}

.elastic-bounce {
  animation: elasticBounce 2s ease infinite;
}

/* Ripple Effect */
@keyframes ripple {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(4);
    opacity: 0;
  }
}

.ripple::after {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: inherit;
  border: 2px solid currentColor;
  animation: ripple 1.5s ease-out infinite;
}

/* Typewriter Cursor */
@keyframes blink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0; }
}

.typewriter-cursor::after {
  content: '|';
  animation: blink 1s step-end infinite;
}

/* Glitch Effect */
@keyframes glitch {
  0%, 100% {
    transform: translate(0);
  }
  20% {
    transform: translate(-2px, 2px);
  }
  40% {
    transform: translate(-2px, -2px);
  }
  60% {
    transform: translate(2px, 2px);
  }
  80% {
    transform: translate(2px, -2px);
  }
}

.glitch-effect:hover {
  animation: glitch 0.3s ease infinite;
}

/* Shake Effect */
@keyframes shake {
  0%, 100% { transform: translateX(0); }
  10%, 30%, 50%, 70%, 90% { transform: translateX(-5px); }
  20%, 40%, 60%, 80% { transform: translateX(5px); }
}

.shake:hover {
  animation: shake 0.5s ease;
}

/* Liquid Fill */
@keyframes liquidFill {
  0% {
    transform: translateY(100%);
  }
  100% {
    transform: translateY(0);
  }
}

/* Spotlight Effect */
.spotlight {
  position: relative;
  overflow: hidden;
}

.spotlight::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(
    circle,
    rgba(255,255,255,0.1) 0%,
    transparent 50%
  );
  transform: translateX(-100%);
  transition: transform 0.6s ease;
}

.spotlight:hover::before {
  transform: translateX(100%);
}

/* Neon Glow */
.neon-glow {
  text-shadow: 
    0 0 5px currentColor,
    0 0 10px currentColor,
    0 0 20px currentColor,
    0 0 40px currentColor;
}

/* Magnetic Button Styles */
.magnetic-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  text-decoration: none;
}

.magnetic-inner {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
}

/* Tilt Card Base */
.tilt-card {
  transform-style: preserve-3d;
  position: relative;
}

/* Reveal on Scroll */
.reveal-on-scroll {
  will-change: transform, opacity;
}


/* Text Scramble */
.text-scramble {
  font-family: inherit;
}

.text-scramble.animating {
  letter-spacing: 0.02em;
}

/* Parallax layers */
.parallax-layer {
  will-change: transform;
}

/* Smooth scroll behavior for the whole page */
html {
  scroll-behavior: smooth;
}

/* Performance optimizations */
.gpu-accelerate {
  transform: translateZ(0);
  backface-visibility: hidden;
  perspective: 1000px;
}

/* (hero effects now live in Home.css) */

/* Disable animations for users who prefer reduced motion */
@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
  
  .magic-cursor,
  .magic-cursor-dot {
    display: none;
  }
}

/* Error & Success States */
.error {
  background: #fef2f2;
  color: #dc2626;
  padding: var(--space-4);
  border-radius: var(--radius-lg);
  border: 1px solid #fecaca;
}

.success {
  background: #f0fdf4;
  color: #16a34a;
  padding: var(--space-4);
  border-radius: var(--radius-lg);
  border: 1px solid #bbf7d0;
}

/* ═══════════════════════════════════════════
   ANNOUNCEMENT BAR — top trust strip
   ═══════════════════════════════════════════ */
.announcement-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 60;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 16px;
  background:
    linear-gradient(90deg, rgba(110,232,149,0.14) 0%, rgba(170,140,255,0.18) 50%, rgba(110,232,149,0.14) 100%);
  border-bottom: 1px solid rgba(170,140,255,0.2);
  animation: announcementShimmer 12s ease-in-out infinite;
  background-size: 200% 100%;
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
}

/* Push the fixed header down below the announcement bar */
body.has-announcement header.fixed {
  top: 42px;
}
@media (max-width: 640px) {
  body.has-announcement header.fixed { top: 40px; }
}
@keyframes announcementShimmer {
  0%, 100% { background-position: 0% 0%; }
  50%      { background-position: 100% 0%; }
}
.announcement-bar-link {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: #ffffff;
  text-decoration: none;
  font-family: 'Montserrat', sans-serif;
  font-size: 13px;
  letter-spacing: 0.04em;
  transition: opacity 0.2s ease;
}
.announcement-bar-link:hover { opacity: 0.85; }
.announcement-bar-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #6ee895;
  box-shadow: 0 0 12px rgba(110,232,149,0.9);
  animation: announcementPulse 2s ease-in-out infinite;
  flex-shrink: 0;
}
@keyframes announcementPulse {
  0%, 100% { transform: scale(1); opacity: 1; }
  50%      { transform: scale(1.25); opacity: 0.8; }
}
.announcement-bar-text {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: center;
}
.announcement-bar-text strong {
  font-weight: 600;
  color: #ffffff;
}
.announcement-bar-sep {
  color: rgba(255,255,255,0.35);
}
.announcement-bar-cta {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #a98fff;
  font-weight: 500;
  transition: color 0.2s ease, transform 0.2s ease;
}
.announcement-bar-link:hover .announcement-bar-cta {
  color: #ffffff;
  transform: translateX(3px);
}
.announcement-bar-close {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: transparent;
  border: 1px solid rgba(255,255,255,0.1);
  color: rgba(255,255,255,0.55);
  cursor: pointer;
  transition: color 0.2s ease, border-color 0.2s ease, background 0.2s ease;
}
.announcement-bar-close:hover {
  color: #ffffff;
  border-color: rgba(255,255,255,0.3);
  background: rgba(255,255,255,0.06);
}
@media (max-width: 640px) {
  .announcement-bar { padding: 9px 40px 9px 14px; font-size: 12px; }
  .announcement-bar-link { font-size: 12px; gap: 8px; }
  .announcement-bar-close { right: 10px; width: 22px; height: 22px; }
}

/* ═══════════════════════════════════════════
   FLOATING CONTACT — always-available action
   ═══════════════════════════════════════════ */
.floating-contact {
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 50;
  opacity: 0;
  transform: translateY(18px);
  transition: opacity 0.3s ease, transform 0.3s ease;
  pointer-events: none;
}
.floating-contact-visible {
  opacity: 1;
  transform: translateY(0);
  pointer-events: auto;
}

.floating-main-btn {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 12px 20px 12px 14px;
  background: linear-gradient(135deg, #a98fff 0%, #7c5cff 100%);
  border: 1px solid rgba(255,255,255,0.18);
  border-radius: 999px;
  color: #100D25;
  font-family: 'Montserrat', sans-serif;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.02em;
  cursor: pointer;
  box-shadow:
    0 10px 30px rgba(140,90,240,0.45),
    0 4px 10px rgba(0,0,0,0.2);
  transition: transform 0.25s ease, box-shadow 0.25s ease;
  z-index: 2;
}
.floating-main-btn:hover {
  transform: translateY(-2px) scale(1.03);
  box-shadow:
    0 14px 40px rgba(170,140,255,0.55),
    0 4px 10px rgba(0,0,0,0.2);
}
.floating-main-label {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.floating-main-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #14b85f;
  box-shadow: 0 0 10px rgba(20,184,95,0.9);
  animation: floatingDotPulse 2s ease-in-out infinite;
}
@keyframes floatingDotPulse {
  0%, 100% { transform: scale(1); }
  50%      { transform: scale(1.35); }
}
.floating-main-icon-close {
  width: 18px;
  height: 18px;
  transition: opacity 0.25s ease, transform 0.25s ease;
}
.floating-main-icon-hidden {
  opacity: 0;
  transform: rotate(-90deg) scale(0.5);
  width: 0;
  margin: 0;
}

.floating-pulse-ring {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  transform: translate(-50%, -50%);
  border-radius: 999px;
  border: 2px solid rgba(170,140,255,0.45);
  animation: floatingPulseRing 2.6s ease-out infinite;
  pointer-events: none;
}
@keyframes floatingPulseRing {
  0%   { transform: translate(-50%, -50%) scale(1);    opacity: 0.7; }
  100% { transform: translate(-50%, -50%) scale(1.45); opacity: 0; }
}
.floating-contact-expanded .floating-pulse-ring {
  animation: none;
  opacity: 0;
}

.floating-options {
  position: absolute;
  bottom: 58px;
  right: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  opacity: 0;
  transform: translateY(10px);
  pointer-events: none;
  transition: opacity 0.3s ease, transform 0.3s ease;
}
.floating-options-show {
  opacity: 1;
  transform: translateY(0);
  pointer-events: auto;
}
.floating-option {
  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  background: rgba(20, 16, 46, 0.92);
  border: 1px solid rgba(170,140,255,0.28);
  border-radius: 50%;
  text-decoration: none;
  backdrop-filter: blur(12px);
  box-shadow: 0 8px 24px rgba(0,0,0,0.35);
  transition: transform 0.25s ease, background 0.25s ease, border-color 0.25s ease;
}
.floating-option:hover {
  transform: scale(1.1);
  background: rgba(170,140,255,0.18);
  border-color: rgba(170,140,255,0.55);
}
.floating-option-whatsapp { color: #25D366; }
.floating-option-calendar { color: #a98fff; }

.floating-scroll-top {
  position: fixed;
  bottom: 26px;
  left: 24px;
  z-index: 50;
  width: 42px;
  height: 42px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(20, 16, 46, 0.8);
  border: 1px solid rgba(170,140,255,0.28);
  border-radius: 50%;
  color: rgba(255,255,255,0.75);
  cursor: pointer;
  backdrop-filter: blur(12px);
  opacity: 0;
  transform: translateY(14px);
  transition: opacity 0.3s ease, transform 0.3s ease, color 0.2s ease, border-color 0.2s ease, background 0.2s ease;
  pointer-events: none;
}
.floating-scroll-top-visible {
  opacity: 1;
  transform: translateY(0);
  pointer-events: auto;
}
.floating-scroll-top:hover {
  color: #a98fff;
  border-color: rgba(170,140,255,0.55);
  background: rgba(170,140,255,0.14);
}

@media (max-width: 640px) {
  .floating-contact { bottom: 16px; right: 16px; }
  .floating-main-btn { padding: 10px 16px 10px 12px; font-size: 12px; }
  .floating-scroll-top { bottom: 16px; left: 16px; width: 38px; height: 38px; }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,yDAAyD;;AAEzD,yBAAyB;;AAGzB,kDAAkD;AAClD;EACE,yCAAyC;EACzC,wBAAwB;EACxB,wBAAwB;EACxB,qBAAqB;EACrB,oBAAoB;;EAEpB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;;EAEnB,6BAA6B;EAC7B,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;;EAEnB,+BAA+B;EAC/B,uBAAuB;EACvB,sBAAsB;EACtB,oBAAoB;EACpB,sBAAsB;EACtB,qBAAqB;;EAErB,sCAAsC;EACtC,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,sBAAsB;;EAEtB,yBAAyB;EACzB,yEAAyE;EACzE,0EAA0E;EAC1E,oFAAoF;EACpF,kFAAkF;EAClF,2EAA2E;EAC3E,uBAAuB;EACvB,mDAAqU;;EAErU,kBAAkB;EAClB,kCAAkC;EAClC,uCAAuC;EACvC,2CAA2C;EAC3C,yCAAyC;EACzC,6CAA6C;EAC7C,+CAA+C;;EAE/C,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;;EAEtB,eAAe;EACf,wCAAwC;EACxC,wCAAwC;EACxC,qCAAqC;;EAErC,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;;EAEhB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;;EAEhB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,qBAAqB;;EAErB,YAAY;EACZ,4CAA4C;EAC5C,8CAA8C;EAC9C,gDAAgD;EAChD,gDAAgD;EAChD,mDAAmD;EACnD,gDAAgD;;EAEhD,gBAAgB;EAChB,qDAAqD;EACrD,uDAAuD;EACvD,qDAAqD;EACrD,iEAAiE;AACnE;;AAEA,eAAe;AACf;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,gCAAgC;EAChC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,gCAAgC;EAChC,8CAA8C;EAC9C,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,4CAA4C;EAC5C,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,8CAA8C;EAC9C,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,+CAA+C;EAC/C,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,sCAAsC;EACtC,iCAAiC;EACjC,gCAAgC;EAChC,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;EACpC,gDAAgD;AAClD;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA,gBAAgB;AAChB;EACE,gCAAgC;EAChC,uCAAuC;EACvC,gCAAgC;EAChC,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,mCAAmC;EACnC,8CAA8C;AAChD;;AAEA;EACE,kCAAkC;EAClC,2CAA2C;AAC7C;;AAEA;EACE,sCAAsC;AACxC;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;;;IAGE,0BAA0B;EAC5B;AACF;;AAEA,cAAc;AACd;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,WAAW,0BAA0B,EAAE;EACvC,MAAM,4BAA4B,EAAE;AACtC;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,yBAAyB;AACzB,aAAa,qBAAqB,EAAE;AACpC,aAAa,qBAAqB,EAAE;AACpC,aAAa,qBAAqB,EAAE;AACpC,aAAa,qBAAqB,EAAE;AACpC,aAAa,qBAAqB,EAAE;;AAEpC,mBAAmB;AACnB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,0CAA0C;EAC1C,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA,cAAc;AACd,eAAe,kBAAkB,EAAE;AACnC,aAAa,gBAAgB,EAAE;AAC/B,cAAc,iBAAiB,EAAE;;AAEjC,cAAc,2BAA2B,EAAE;AAC3C,cAAc,cAAc,EAAE;AAC9B,aAAa,sBAAsB,EAAE;AACrC,aAAa,2BAA2B,EAAE;;AAE1C,YAAY,mBAAmB,EAAE;AACjC,YAAY,gCAAgC,EAAE;AAC9C,WAAW,mBAAmB,EAAE;AAChC,WAAW,mBAAmB,EAAE;;AAEhC,0BAA0B;AAC1B;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,iCAAiC;EACjC,YAAY;EACZ,oBAAoB;AACtB;;AAEA,kBAAkB;AAClB;EACE,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;AACtC;;AAEA,cAAc;AACd;EACE,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA,iBAAiB;AACjB;EACE,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA,0BAA0B;AAC1B;EACE;IACE,kCAAkC;EACpC;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,oCAAoC;EACtC;AACF;;AAEA,4BAA4B;AAC5B;EACE,SAAO;AACT;;AAEA;;gDAEgD;;AAEhD;;kEAEkE;AAClE;EACE,gBAAgB;EAChB;;;;uBAIqB;EACrB,0BAA0B;EAC1B,uDAAuD;AACzD;AACA;EACE,WAAW,4BAA4B,EAAE;EACzC,WAAW,6BAA6B,EAAE;AAC5C;;AAEA;;oEAEoE;AACpE;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,2BAA2B;EAC3B,mCAAmC;EACnC,iEAAiE;EACjE,+BAA+B;AACjC;;AAEA,kCAAkC;AAClC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,UAAU;EACV,YAAY;EACZ;;;;;;;gBAOc;EACd;;kCAEgC;EAChC,yEAAyE;AAC3E;AACA;EACE,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE;AACrB;;AAEA,0DAA0D;AAC1D,wCAAwC,SAAS,EAAE;AACnD;EACE,wCAAwC,SAAS,EAAE;AACrD;;AAEA;yDACyD;AACzD;EACE,yBAAyB,eAAe,EAAE,YAAY,EAAE;AAC1D;;AAEA;;;;;;gDAMgD;;AAEhD;;8BAE8B;AAC9B;;EAEE,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE;AACrB;AACA;EACE,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE;AACrB;;AAEA;+EAC+E;AAC/E;;;;;EAKE,0BAA0B;AAC5B;;AAEA;;2CAE2C;;AAE3C;EACE,eAAe;EACf,QAAQ;EACR,0EAA0E;EAC1E,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,qBAAqB;EACvB;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,4CAA4C;EAC5C,sDAAsD;AACxD;;AAEA;EACE;IACE,UAAU;IACV,sDAAsD;EACxD;EACA;IACE,aAAa;IACb,sDAAsD;EACxD;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,+BAA+B;EAC/B,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,0FAA0F;EAC1F,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,YAAY;EACZ,wBAAwB;EACxB,mDAAmD;AACrD;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,SAAS;EACT,8CAA8C;EAC9C,0CAA0C;AAC5C;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,YAAY;IACZ,uDAAuD;EACzD;EACA;IACE,aAAa;IACb,yDAAyD;EAC3D;AACF;;AAEA;;2CAE2C;;AAE3C;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,YAAY;EACZ,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,OAAO;EACP,gEAAgE;AAClE;;AAEA;EACE,QAAQ;EACR,gEAAgE;AAClE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;;2CAE2C;;AAE3C,4BAA4B;AAC5B;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,0BAA0B;EAC1B,sCAAsC;AACxC;;AAEA,sBAAsB;AACtB;EACE;IACE,6CAA6C;EAC/C;EACA;IACE,gFAAgF;EAClF;AACF;;AAEA;EACE,4CAA4C;AAC9C;;AAEA,wBAAwB;AACxB;EACE;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE;;;;;GAKC;EACD,0BAA0B;EAC1B,0CAA0C;EAC1C,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA,6BAA6B;AAC7B;EACE;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,gBAAgB;AAChB;EACE;IACE,4CAA4C;EAC9C;EACA;IACE,8CAA8C;EAChD;AACF;;AAEA;EACE,uCAAuC;AACzC;;AAEA,mBAAmB;AACnB;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,kBAAkB;AAClB;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,sBAAsB;EACtB,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA,sBAAsB;AACtB;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,UAAU,EAAE;AACpB;;AAEA;EACE,YAAY;EACZ,qCAAqC;AACvC;;AAEA,kBAAkB;AAClB;EACE;IACE,uBAAuB;EACzB;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,+BAA+B;EACjC;AACF;;AAEA;EACE,oCAAoC;AACtC;;AAEA,iBAAiB;AACjB;EACE,WAAW,wBAAwB,EAAE;EACrC,0BAA0B,2BAA2B,EAAE;EACvD,qBAAqB,0BAA0B,EAAE;AACnD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,gBAAgB;AAChB;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ;;;;GAIC;EACD,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,cAAc;AACd;EACE;;;;yBAIuB;AACzB;;AAEA,2BAA2B;AAC3B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;AACZ;;AAEA,mBAAmB;AACnB;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,+BAA+B;AACjC;;;AAGA,kBAAkB;AAClB;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,oBAAoB;AACpB;EACE,sBAAsB;AACxB;;AAEA,8CAA8C;AAC9C;EACE,uBAAuB;AACzB;;AAEA,8BAA8B;AAC9B;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA,wCAAwC;;AAExC,2DAA2D;AAC3D;EACE;;;IAGE,qCAAqC;IACrC,uCAAuC;IACvC,sCAAsC;EACxC;;EAEA;;IAEE,aAAa;EACf;AACF;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;EACnB,cAAc;EACd,uBAAuB;EACvB,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,uBAAuB;EACvB,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;;gDAEgD;AAChD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB;8GAC4G;EAC5G,8CAA8C;EAC9C,uDAAuD;EACvD,0BAA0B;EAC1B,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA,0DAA0D;AAC1D;EACE,SAAS;AACX;AACA;EACE,qCAAqC,SAAS,EAAE;AAClD;AACA;EACE,WAAW,0BAA0B,EAAE;EACvC,WAAW,4BAA4B,EAAE;AAC3C;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,qBAAqB;EACrB,qCAAqC;EACrC,eAAe;EACf,sBAAsB;EACtB,6BAA6B;AAC/B;AACA,+BAA+B,aAAa,EAAE;AAC9C;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,oDAAoD;EACpD,cAAc;AAChB;AACA;EACE,WAAW,mBAAmB,EAAE,UAAU,EAAE;EAC5C,WAAW,sBAAsB,EAAE,YAAY,EAAE;AACnD;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,gDAAgD;AAClD;AACA;EACE,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,uCAAuC;EACvC,6BAA6B;EAC7B,eAAe;EACf,yEAAyE;AAC3E;AACA;EACE,cAAc;EACd,mCAAmC;EACnC,kCAAkC;AACpC;AACA;EACE,oBAAoB,0BAA0B,EAAE,eAAe,EAAE;EACjE,yBAAyB,eAAe,EAAE,QAAQ,EAAE;EACpD,0BAA0B,WAAW,EAAE,WAAW,EAAE,YAAY,EAAE;AACpE;;AAEA;;gDAEgD;AAChD;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,WAAW;EACX,UAAU;EACV,2BAA2B;EAC3B,kDAAkD;EAClD,oBAAoB;AACtB;AACA;EACE,UAAU;EACV,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,4BAA4B;EAC5B,6DAA6D;EAC7D,wCAAwC;EACxC,oBAAoB;EACpB,cAAc;EACd,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf;;8BAE4B;EAC5B,uDAAuD;EACvD,UAAU;AACZ;AACA;EACE,uCAAuC;EACvC;;8BAE4B;AAC9B;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,wCAAwC;EACxC,mDAAmD;AACrD;AACA;EACE,WAAW,mBAAmB,EAAE;EAChC,WAAW,sBAAsB,EAAE;AACrC;AACA;EACE,WAAW;EACX,YAAY;EACZ,oDAAoD;AACtD;AACA;EACE,UAAU;EACV,oCAAoC;EACpC,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,oBAAoB;EACpB,wCAAwC;EACxC,mDAAmD;EACnD,oBAAoB;AACtB;AACA;EACE,OAAO,yCAAyC,KAAK,YAAY,EAAE;EACnE,OAAO,4CAA4C,EAAE,UAAU,EAAE;AACnE;AACA;EACE,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,2BAA2B;EAC3B,oBAAoB;EACpB,kDAAkD;AACpD;AACA;EACE,UAAU;EACV,wBAAwB;EACxB,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kCAAkC;EAClC,wCAAwC;EACxC,kBAAkB;EAClB,qBAAqB;EACrB,2BAA2B;EAC3B,uCAAuC;EACvC,gFAAgF;AAClF;AACA;EACE,qBAAqB;EACrB,kCAAkC;EAClC,oCAAoC;AACtC;AACA,4BAA4B,cAAc,EAAE;AAC5C,4BAA4B,cAAc,EAAE;;AAE5C;EACE,eAAe;EACf,YAAY;EACZ,UAAU;EACV,WAAW;EACX,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,wCAAwC;EACxC,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,2BAA2B;EAC3B,UAAU;EACV,2BAA2B;EAC3B,iHAAiH;EACjH,oBAAoB;AACtB;AACA;EACE,UAAU;EACV,wBAAwB;EACxB,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA;EACE,oBAAoB,YAAY,EAAE,WAAW,EAAE;EAC/C,qBAAqB,4BAA4B,EAAE,eAAe,EAAE;EACpE,uBAAuB,YAAY,EAAE,UAAU,EAAE,WAAW,EAAE,YAAY,EAAE;AAC9E","sourcesContent":["/* Markhor Systems - Modern Black & White Design System */\n\n/* Import Premium Fonts */\n@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap');\n\n/* CSS Custom Properties for Midnight Blue Theme */\n:root {\n  /* Primary Colors - Midnight Blue Theme */\n  --primary-black: #100D25;\n  --primary-white: #FFFFFF;\n  --pure-black: #0a0815;\n  --off-white: #f8f9ff;\n\n  /* Blue Scale */\n  --blue-50: #eff6ff;\n  --blue-100: #dbeafe;\n  --blue-200: #bfdbfe;\n  --blue-300: #93c5fd;\n  --blue-400: #60a5fa;\n  --blue-500: #3b82f6;\n  --blue-600: #2563eb;\n  --blue-700: #1d4ed8;\n  --blue-800: #1e40af;\n  --blue-900: #1e3a8a;\n  --blue-950: #172554;\n\n  /* Gray Scale (Blue-tinted) */\n  --gray-50: #f8fafc;\n  --gray-100: #f1f5f9;\n  --gray-200: #e2e8f0;\n  --gray-300: #cbd5e1;\n  --gray-400: #94a3b8;\n  --gray-500: #64748b;\n  --gray-600: #475569;\n  --gray-700: #334155;\n  --gray-800: #1e293b;\n  --gray-900: #0f172a;\n  --gray-950: #020617;\n\n  /* Midnight Blue Theme Colors */\n  --navy-darkest: #0a0815;\n  --navy-darker: #100D25;\n  --navy-dark: #16122f;\n  --navy-medium: #1e1a3a;\n  --navy-light: #252145;\n\n  /* Accent Colors - Purple Variations */\n  --accent-light: #ede9fe;\n  --accent-dark: #5b21b6;\n  --accent-hover: #7c3aed;\n  --accent-primary: #8b5cf6;\n  --accent-glow: #a78bfa;\n\n  /* Background Gradients */\n  --bg-dark: linear-gradient(180deg, #100D25 0%, #16122f 50%, #1e1a3a 100%);\n  --bg-light: linear-gradient(180deg, #FFFFFF 0%, #f8f9ff 50%, #e8ebff 100%);\n  --bg-gradient-subtle: linear-gradient(135deg, #100D25 0%, #16122f 50%, #1e1a3a 100%);\n  --bg-gradient-hero: linear-gradient(135deg, #100D25 0%, #1e1a3a 50%, #16122f 100%);\n  --bg-accent: linear-gradient(135deg, #FFFFFF 0%, #f0f0f0 50%, #e0e0e0 100%);\n  --bg-secondary: #16122f;\n  --bg-noise: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)' opacity='0.02'/%3E%3C/svg%3E\");\n\n  /* Glass Effects */\n  --glass-bg: rgba(16, 13, 37, 0.95);\n  --glass-bg-dark: rgba(16, 13, 37, 0.98);\n  --glass-bg-light: rgba(255, 255, 255, 0.98);\n  --glass-border: rgba(255, 255, 255, 0.15);\n  --glass-border-dark: rgba(255, 255, 255, 0.2);\n  --glass-border-light: rgba(255, 255, 255, 0.08);\n\n  /* Primary Theme Colors */\n  --primary-100: #ede9fe;\n  --primary-200: #ddd6fe;\n  --primary-300: #c4b5fd;\n  --primary-400: #a78bfa;\n  --primary-500: #8b5cf6;\n  --primary-600: #7c3aed;\n  \n  /* Typography */\n  --font-display: 'Montserrat', sans-serif;\n  --font-heading: 'Montserrat', sans-serif;\n  --font-body: 'Montserrat', sans-serif;\n  \n  /* Font Sizes */\n  --text-xs: 0.75rem;\n  --text-sm: 0.875rem;\n  --text-base: 1rem;\n  --text-lg: 1.125rem;\n  --text-xl: 1.25rem;\n  --text-2xl: 1.5rem;\n  --text-3xl: 1.875rem;\n  --text-4xl: 2.25rem;\n  --text-5xl: 3rem;\n  --text-6xl: 3.75rem;\n  --text-7xl: 4.5rem;\n  --text-8xl: 6rem;\n  \n  /* Spacing */\n  --space-1: 0.25rem;\n  --space-2: 0.5rem;\n  --space-3: 0.75rem;\n  --space-4: 1rem;\n  --space-5: 1.25rem;\n  --space-6: 1.5rem;\n  --space-8: 2rem;\n  --space-10: 2.5rem;\n  --space-12: 3rem;\n  --space-16: 4rem;\n  --space-20: 5rem;\n  --space-24: 6rem;\n  --space-32: 8rem;\n  \n  /* Border Radius */\n  --radius-sm: 0.25rem;\n  --radius-md: 0.5rem;\n  --radius-lg: 0.75rem;\n  --radius-xl: 1rem;\n  --radius-2xl: 1.5rem;\n  --radius-3xl: 2rem;\n  --radius-full: 9999px;\n  \n  /* Shadows */\n  --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1);\n  --shadow-xl: 0 20px 25px -5px rgba(0, 0, 0, 0.1);\n  --shadow-2xl: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  --shadow-glow: 0 0 60px rgba(255, 255, 255, 0.1);\n  \n  /* Transitions */\n  --transition-fast: 150ms cubic-bezier(0.4, 0, 0.2, 1);\n  --transition-normal: 300ms cubic-bezier(0.4, 0, 0.2, 1);\n  --transition-slow: 500ms cubic-bezier(0.4, 0, 0.2, 1);\n  --transition-bounce: 500ms cubic-bezier(0.68, -0.55, 0.265, 1.55);\n}\n\n/* App Layout */\n.App {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  background: var(--primary-white);\n  position: relative;\n  overflow-x: hidden;\n}\n\n/* Typography Classes */\n.heading-hero {\n  font-family: var(--font-display);\n  font-size: clamp(2.5rem, 8vw, var(--text-7xl));\n  font-weight: 800;\n  line-height: 1.05;\n  letter-spacing: -0.03em;\n}\n\n.heading-page {\n  font-family: var(--font-display);\n  font-size: clamp(2rem, 5vw, var(--text-5xl));\n  font-weight: 700;\n  line-height: 1.1;\n  letter-spacing: -0.02em;\n}\n\n.heading-section {\n  font-family: var(--font-heading);\n  font-size: clamp(1.5rem, 4vw, var(--text-4xl));\n  font-weight: 600;\n  line-height: 1.2;\n  letter-spacing: -0.01em;\n}\n\n.heading-subsection {\n  font-family: var(--font-heading);\n  font-size: clamp(1.25rem, 3vw, var(--text-2xl));\n  font-weight: 600;\n  line-height: 1.3;\n}\n\n.text-body {\n  font-family: var(--font-body);\n  font-size: var(--text-base);\n  font-weight: 400;\n  line-height: 1.7;\n}\n\n.text-large {\n  font-family: var(--font-body);\n  font-size: var(--text-lg);\n  font-weight: 400;\n  line-height: 1.7;\n}\n\n/* Button System */\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-2);\n  padding: var(--space-4) var(--space-8);\n  border-radius: var(--radius-full);\n  font-family: var(--font-heading);\n  font-weight: 500;\n  font-size: var(--text-sm);\n  text-decoration: none;\n  border: none;\n  cursor: pointer;\n  transition: all var(--transition-normal);\n  position: relative;\n  overflow: hidden;\n}\n\n.btn-primary {\n  background: var(--primary-white);\n  color: var(--primary-black);\n  border: 2px solid var(--primary-white);\n}\n\n.btn-primary:hover {\n  background: rgba(255, 255, 255, 0.9);\n  box-shadow: 0 10px 40px rgba(255, 255, 255, 0.3);\n}\n\n.btn-secondary {\n  background: transparent;\n  color: var(--primary-white);\n  border: 2px solid var(--primary-white);\n}\n\n.btn-secondary:hover {\n  background: var(--primary-white);\n  color: var(--primary-black);\n  border-color: var(--primary-white);\n}\n\n.btn-white {\n  background: var(--primary-white);\n  color: var(--primary-black);\n  border: 2px solid var(--primary-white);\n}\n\n.btn-white:hover {\n  background: rgba(255, 255, 255, 0.9);\n  color: var(--primary-black);\n  border-color: var(--primary-white);\n}\n\n.btn-ghost {\n  background: transparent;\n  color: var(--primary-white);\n  border: 2px solid rgba(255, 255, 255, 0.3);\n}\n\n.btn-ghost:hover {\n  border-color: var(--primary-white);\n  background: rgba(255, 255, 255, 0.1);\n}\n\n/* Card System */\n.card {\n  background: var(--primary-white);\n  border: 1px solid rgba(16, 13, 37, 0.1);\n  border-radius: var(--radius-2xl);\n  padding: var(--space-8);\n  transition: all var(--transition-normal);\n}\n\n.card:hover {\n  border-color: rgba(16, 13, 37, 0.2);\n  box-shadow: 0 20px 40px rgba(16, 13, 37, 0.15);\n}\n\n.card-dark {\n  background: rgba(16, 13, 37, 0.95);\n  border: 1px solid rgba(255, 255, 255, 0.15);\n}\n\n.card-dark:hover {\n  border-color: rgba(255, 255, 255, 0.3);\n}\n\n/* Section Backgrounds */\n.section-dark {\n  background: #100D25;\n  color: var(--primary-white);\n}\n\n.section-light {\n  background: var(--primary-white);\n  color: #100D25;\n}\n\n.section-gray {\n  background: #f8f9ff;\n  color: #100D25;\n}\n\n/* Grid System */\n.grid {\n  display: grid;\n  gap: var(--space-8);\n}\n\n.grid-2 {\n  grid-template-columns: repeat(2, 1fr);\n}\n\n.grid-3 {\n  grid-template-columns: repeat(3, 1fr);\n}\n\n.grid-4 {\n  grid-template-columns: repeat(4, 1fr);\n}\n\n@media (max-width: 1024px) {\n  .grid-4 {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  .grid-3 {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 768px) {\n  .grid-2,\n  .grid-3,\n  .grid-4 {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Container */\n.container {\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 0 var(--space-6);\n  width: 100%;\n}\n\n/* Animation Classes */\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(40px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateX(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes float {\n  0%, 100% { transform: translateY(0px); }\n  50% { transform: translateY(-20px); }\n}\n\n@keyframes pulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.5; }\n}\n\n@keyframes spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n.animate-fadeInUp {\n  animation: fadeInUp 0.8s ease-out forwards;\n}\n\n.animate-fadeIn {\n  animation: fadeIn 0.6s ease-out forwards;\n}\n\n.animate-slideIn {\n  animation: slideIn 0.6s ease-out forwards;\n}\n\n.animate-float {\n  animation: float 6s ease-in-out infinite;\n}\n\n/* Staggered Animations */\n.stagger-1 { animation-delay: 0.1s; }\n.stagger-2 { animation-delay: 0.2s; }\n.stagger-3 { animation-delay: 0.3s; }\n.stagger-4 { animation-delay: 0.4s; }\n.stagger-5 { animation-delay: 0.5s; }\n\n/* Loading States */\n.loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: var(--space-12);\n}\n\n.loading::after {\n  content: '';\n  width: 40px;\n  height: 40px;\n  border: 3px solid rgba(255, 255, 255, 0.2);\n  border-top: 3px solid var(--primary-white);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n/* Utilities */\n.text-center { text-align: center; }\n.text-left { text-align: left; }\n.text-right { text-align: right; }\n\n.text-white { color: var(--primary-white); }\n.text-black { color: #100D25; }\n.text-gray { color: var(--gray-500); }\n.text-blue { color: var(--primary-white); }\n\n.bg-black { background: #100D25; }\n.bg-white { background: var(--primary-white); }\n.bg-gray { background: #f8f9ff; }\n.bg-navy { background: #16122f; }\n\n/* Noise Texture Overlay */\n.noise-overlay::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background-image: var(--bg-noise);\n  opacity: 0.4;\n  pointer-events: none;\n}\n\n/* Gradient Text */\n.gradient-text {\n  background: linear-gradient(135deg, #FFFFFF 0%, #cccccc 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.gradient-text-white {\n  background: linear-gradient(135deg, #FFFFFF 0%, #e0e0e0 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n/* Scrollbar Styling */\n::-webkit-scrollbar {\n  width: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: #16122f;\n}\n\n::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.4);\n  border-radius: var(--radius-full);\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: rgba(255, 255, 255, 0.6);\n}\n\n/* Selection */\n::selection {\n  background: var(--primary-white);\n  color: var(--primary-black);\n}\n\n/* Focus States */\n*:focus {\n  outline: 2px solid var(--primary-white);\n  outline-offset: 2px;\n}\n\n*:focus:not(:focus-visible) {\n  outline: none;\n}\n\n/* Responsive Typography */\n@media (max-width: 768px) {\n  .heading-hero {\n    font-size: clamp(2rem, 10vw, 3rem);\n  }\n  \n  .heading-page {\n    font-size: clamp(1.75rem, 6vw, 2.5rem);\n  }\n  \n  .heading-section {\n    font-size: clamp(1.25rem, 5vw, 2rem);\n  }\n}\n\n/* Smooth Page Transitions */\nmain {\n  flex: 1;\n}\n\n/* ═══════════════════════════════════════════\n   PAGE TRANSITIONS — Motion (AnimatePresence) driven\n   ═══════════════════════════════════════════ */\n\n/* Suspense fallback — subtle shimmer instead of blank flash.\n   Ideally this never shows because all routes are preloaded,\n   but it's here as a graceful fallback on the very first visit. */\n.page-loading {\n  min-height: 70vh;\n  background:\n    linear-gradient(90deg,\n      transparent 0%,\n      rgba(170,140,255,0.06) 50%,\n      transparent 100%);\n  background-size: 200% 100%;\n  animation: pageLoadingShimmer 1.4s ease-in-out infinite;\n}\n@keyframes pageLoadingShimmer {\n  0%, 100% { background-position: 200% 0%; }\n  50%      { background-position: -200% 0%; }\n}\n\n/* The wrapper applied to each motion.div page.\n   We only set GPU hints — Motion controls the actual transform/opacity\n   via inline styles, so no CSS transitions here (would conflict). */\n.page-motion {\n  min-height: 70vh;\n  transform-origin: center top;\n  backface-visibility: hidden;\n  -webkit-backface-visibility: hidden;\n  /* Trick the browser into compositing this on its own GPU layer */\n  transform: translate3d(0, 0, 0);\n}\n\n/* Top route-change progress bar */\n.route-progress {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 2px;\n  z-index: 100;\n  pointer-events: none;\n  overflow: hidden;\n}\n.route-progress::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -35%;\n  width: 35%;\n  height: 100%;\n  background: linear-gradient(90deg,\n    transparent,\n    rgba(170,140,255,0.3) 20%,\n    #a98fff 45%,\n    #ffffff 50%,\n    #a98fff 55%,\n    rgba(170,140,255,0.3) 80%,\n    transparent);\n  box-shadow:\n    0 0 10px rgba(170,140,255,0.8),\n    0 0 20px rgba(170,140,255,0.4);\n  animation: routeProgressSlide 0.95s cubic-bezier(0.4, 0, 0.2, 1) infinite;\n}\n@keyframes routeProgressSlide {\n  0%   { left: -35%; }\n  100% { left: 100%; }\n}\n\n/* Push progress bar below announcement bar when visible */\nbody.has-announcement .route-progress { top: 42px; }\n@media (max-width: 640px) {\n  body.has-announcement .route-progress { top: 40px; }\n}\n\n/* Reduced motion — Motion respects prefers-reduced-motion internally,\n   but we still remove the progress-bar slide animation */\n@media (prefers-reduced-motion: reduce) {\n  .route-progress::after { animation: none; opacity: 0.4; }\n}\n\n/* ═══════════════════════════════════════════\n   VIEW TRANSITIONS API (native browser layer)\n   When the browser supports it (Chrome/Edge/Safari TP, 85% coverage\n   in 2025), react-router-dom v7's viewTransition prop triggers\n   document.startViewTransition() — the browser snapshots the old\n   and new DOM and cross-fades them on the compositor thread.\n   ═══════════════════════════════════════════ */\n\n/* Root view transition — let our Motion animations drive, but keep\n   a graceful fallback duration if the browser fires the transition\n   before Motion takes over. */\n::view-transition-old(root),\n::view-transition-new(root) {\n  animation-duration: 260ms;\n  animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);\n}\n::view-transition-old(root) {\n  animation-name: vtFadeOut;\n}\n::view-transition-new(root) {\n  animation-name: vtFadeIn;\n}\n@keyframes vtFadeOut {\n  from { opacity: 1; }\n  to   { opacity: 0; }\n}\n@keyframes vtFadeIn {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}\n\n/* Keep the fixed chrome (header, announcement bar, floating button,\n   scroll-top) stable during the native cross-fade so they don't double-paint */\nheader.fixed,\n.announcement-bar,\n.floating-contact,\n.floating-scroll-top,\n.route-progress {\n  view-transition-name: none;\n}\n\n/* ======================================\n   LOADING SCREEN STYLES\n   ====================================== */\n\n.loading-screen {\n  position: fixed;\n  inset: 0;\n  background: linear-gradient(135deg, #100D25 0%, #16122f 50%, #1e1a3a 100%);\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n\n.loading-screen.exit {\n  animation: loadingExit 0.6s ease-out forwards;\n}\n\n@keyframes loadingExit {\n  0% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  100% {\n    opacity: 0;\n    transform: scale(1.1);\n  }\n}\n\n.loading-content {\n  text-align: center;\n  z-index: 2;\n}\n\n.loading-logo {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 48px;\n  animation: logoEnter 0.8s ease-out both;\n}\n\n@keyframes logoEnter {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.loading-logo-img {\n  width: 120px;\n  height: 120px;\n  position: relative;\n  animation: logoPulse 2s ease-in-out infinite;\n  filter: drop-shadow(0 0 30px rgba(129, 140, 248, 0.4));\n}\n\n@keyframes logoPulse {\n  0%, 100% {\n    opacity: 1;\n    filter: drop-shadow(0 0 30px rgba(129, 140, 248, 0.4));\n  }\n  50% {\n    opacity: 0.75;\n    filter: drop-shadow(0 0 50px rgba(167, 139, 250, 0.6));\n  }\n}\n\n.logo-text {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.logo-name {\n  font-family: 'Montserrat', sans-serif;\n  font-size: 32px;\n  font-weight: 700;\n  color: white;\n  letter-spacing: 0.1em;\n}\n\n.logo-tagline {\n  font-family: 'Montserrat', sans-serif;\n  font-size: 14px;\n  color: rgba(255, 255, 255, 0.5);\n  letter-spacing: 0.3em;\n  text-transform: uppercase;\n  margin-top: 4px;\n}\n\n.loading-progress {\n  width: 200px;\n  height: 2px;\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 4px;\n  overflow: hidden;\n  margin: 0 auto;\n}\n\n.progress-bar {\n  height: 100%;\n  background: linear-gradient(90deg, var(--primary-white) 0%, rgba(255, 255, 255, 0.8) 100%);\n  border-radius: 4px;\n  transition: width 0.1s linear;\n}\n\n.loading-percentage {\n  font-family: 'Montserrat', sans-serif;\n  font-size: 14px;\n  color: rgba(255, 255, 255, 0.4);\n  margin-top: 16px;\n  letter-spacing: 0.2em;\n}\n\n/* Loading Background Elements */\n.loading-bg-elements {\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n}\n\n.bg-element {\n  position: absolute;\n  border: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.bg-element-1 {\n  width: 400px;\n  height: 400px;\n  top: -100px;\n  left: -100px;\n  border-radius: 50%;\n  animation: bgFloat 10s ease-in-out infinite;\n}\n\n.bg-element-2 {\n  width: 300px;\n  height: 300px;\n  bottom: -50px;\n  right: -50px;\n  transform: rotate(45deg);\n  animation: bgFloat 12s ease-in-out infinite reverse;\n}\n\n.bg-element-3 {\n  width: 200px;\n  height: 200px;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%) rotate(45deg);\n  animation: bgPulse 4s ease-in-out infinite;\n}\n\n@keyframes bgFloat {\n  0%, 100% {\n    transform: translate(0, 0);\n  }\n  50% {\n    transform: translate(30px, -30px);\n  }\n}\n\n@keyframes bgPulse {\n  0%, 100% {\n    opacity: 0.1;\n    transform: translate(-50%, -50%) rotate(45deg) scale(1);\n  }\n  50% {\n    opacity: 0.05;\n    transform: translate(-50%, -50%) rotate(45deg) scale(1.2);\n  }\n}\n\n/* ======================================\n   MARQUEE STYLES\n   ====================================== */\n\n.marquee-container {\n  width: 100%;\n  overflow: hidden;\n  position: relative;\n}\n\n.marquee-container::before,\n.marquee-container::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 100px;\n  z-index: 2;\n  pointer-events: none;\n}\n\n.marquee-container::before {\n  left: 0;\n  background: linear-gradient(90deg, #16122f 0%, transparent 100%);\n}\n\n.marquee-container::after {\n  right: 0;\n  background: linear-gradient(90deg, transparent 0%, #16122f 100%);\n}\n\n.marquee-track {\n  display: flex;\n  align-items: center;\n  animation: marquee 30s linear infinite;\n  width: max-content;\n}\n\n.marquee-track:hover {\n  animation-play-state: paused;\n}\n\n.marquee-item {\n  transition: color 0.3s ease;\n}\n\n.marquee-item:hover {\n  color: var(--primary-white);\n}\n\n@keyframes marquee {\n  0% {\n    transform: translateX(0);\n  }\n  100% {\n    transform: translateX(-50%);\n  }\n}\n\n/* ======================================\n   CRAZY ANIMATION EFFECTS\n   ====================================== */\n\n/* Gradient Text Animation */\n@keyframes gradient-x {\n  0%, 100% {\n    background-position: 0% 50%;\n  }\n  50% {\n    background-position: 100% 50%;\n  }\n}\n\n.animate-gradient-x {\n  background-size: 200% 200%;\n  animation: gradient-x 3s ease infinite;\n}\n\n/* Glow Pulse Effect */\n@keyframes glowPulse {\n  0%, 100% {\n    box-shadow: 0 0 20px rgba(255, 255, 255, 0.1);\n  }\n  50% {\n    box-shadow: 0 0 40px rgba(255, 255, 255, 0.3), 0 0 60px rgba(255, 255, 255, 0.1);\n  }\n}\n\n.glow-pulse {\n  animation: glowPulse 2s ease-in-out infinite;\n}\n\n/* Text Shimmer Effect */\n@keyframes shimmer {\n  0% {\n    background-position: -200% center;\n  }\n  100% {\n    background-position: 200% center;\n  }\n}\n\n.text-shimmer {\n  background: linear-gradient(\n    90deg,\n    rgba(255,255,255,0) 0%,\n    rgba(255,255,255,0.5) 50%,\n    rgba(255,255,255,0) 100%\n  );\n  background-size: 200% 100%;\n  animation: shimmer 3s ease-in-out infinite;\n  -webkit-background-clip: text;\n  background-clip: text;\n}\n\n/* Morphing Shape Animation */\n@keyframes morph {\n  0%, 100% {\n    border-radius: 60% 40% 30% 70% / 60% 30% 70% 40%;\n  }\n  25% {\n    border-radius: 30% 60% 70% 40% / 50% 60% 30% 60%;\n  }\n  50% {\n    border-radius: 50% 60% 30% 60% / 30% 60% 70% 40%;\n  }\n  75% {\n    border-radius: 60% 40% 60% 30% / 70% 30% 50% 60%;\n  }\n}\n\n.morph-shape {\n  animation: morph 8s ease-in-out infinite;\n}\n\n/* 3D Rotation */\n@keyframes rotate3d {\n  0% {\n    transform: perspective(1000px) rotateY(0deg);\n  }\n  100% {\n    transform: perspective(1000px) rotateY(360deg);\n  }\n}\n\n.rotate-3d {\n  animation: rotate3d 20s linear infinite;\n}\n\n/* Elastic Bounce */\n@keyframes elasticBounce {\n  0%, 100% {\n    transform: translateY(0);\n  }\n  30% {\n    transform: translateY(-30px);\n  }\n  50% {\n    transform: translateY(-15px);\n  }\n  65% {\n    transform: translateY(-25px);\n  }\n  80% {\n    transform: translateY(-10px);\n  }\n}\n\n.elastic-bounce {\n  animation: elasticBounce 2s ease infinite;\n}\n\n/* Ripple Effect */\n@keyframes ripple {\n  0% {\n    transform: scale(1);\n    opacity: 1;\n  }\n  100% {\n    transform: scale(4);\n    opacity: 0;\n  }\n}\n\n.ripple::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  border-radius: inherit;\n  border: 2px solid currentColor;\n  animation: ripple 1.5s ease-out infinite;\n}\n\n/* Typewriter Cursor */\n@keyframes blink {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0; }\n}\n\n.typewriter-cursor::after {\n  content: '|';\n  animation: blink 1s step-end infinite;\n}\n\n/* Glitch Effect */\n@keyframes glitch {\n  0%, 100% {\n    transform: translate(0);\n  }\n  20% {\n    transform: translate(-2px, 2px);\n  }\n  40% {\n    transform: translate(-2px, -2px);\n  }\n  60% {\n    transform: translate(2px, 2px);\n  }\n  80% {\n    transform: translate(2px, -2px);\n  }\n}\n\n.glitch-effect:hover {\n  animation: glitch 0.3s ease infinite;\n}\n\n/* Shake Effect */\n@keyframes shake {\n  0%, 100% { transform: translateX(0); }\n  10%, 30%, 50%, 70%, 90% { transform: translateX(-5px); }\n  20%, 40%, 60%, 80% { transform: translateX(5px); }\n}\n\n.shake:hover {\n  animation: shake 0.5s ease;\n}\n\n/* Liquid Fill */\n@keyframes liquidFill {\n  0% {\n    transform: translateY(100%);\n  }\n  100% {\n    transform: translateY(0);\n  }\n}\n\n/* Spotlight Effect */\n.spotlight {\n  position: relative;\n  overflow: hidden;\n}\n\n.spotlight::before {\n  content: '';\n  position: absolute;\n  top: -50%;\n  left: -50%;\n  width: 200%;\n  height: 200%;\n  background: radial-gradient(\n    circle,\n    rgba(255,255,255,0.1) 0%,\n    transparent 50%\n  );\n  transform: translateX(-100%);\n  transition: transform 0.6s ease;\n}\n\n.spotlight:hover::before {\n  transform: translateX(100%);\n}\n\n/* Neon Glow */\n.neon-glow {\n  text-shadow: \n    0 0 5px currentColor,\n    0 0 10px currentColor,\n    0 0 20px currentColor,\n    0 0 40px currentColor;\n}\n\n/* Magnetic Button Styles */\n.magnetic-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  text-decoration: none;\n}\n\n.magnetic-inner {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  z-index: 1;\n}\n\n/* Tilt Card Base */\n.tilt-card {\n  transform-style: preserve-3d;\n  position: relative;\n}\n\n/* Reveal on Scroll */\n.reveal-on-scroll {\n  will-change: transform, opacity;\n}\n\n\n/* Text Scramble */\n.text-scramble {\n  font-family: inherit;\n}\n\n.text-scramble.animating {\n  letter-spacing: 0.02em;\n}\n\n/* Parallax layers */\n.parallax-layer {\n  will-change: transform;\n}\n\n/* Smooth scroll behavior for the whole page */\nhtml {\n  scroll-behavior: smooth;\n}\n\n/* Performance optimizations */\n.gpu-accelerate {\n  transform: translateZ(0);\n  backface-visibility: hidden;\n  perspective: 1000px;\n}\n\n/* (hero effects now live in Home.css) */\n\n/* Disable animations for users who prefer reduced motion */\n@media (prefers-reduced-motion: reduce) {\n  *,\n  *::before,\n  *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n  }\n  \n  .magic-cursor,\n  .magic-cursor-dot {\n    display: none;\n  }\n}\n\n/* Error & Success States */\n.error {\n  background: #fef2f2;\n  color: #dc2626;\n  padding: var(--space-4);\n  border-radius: var(--radius-lg);\n  border: 1px solid #fecaca;\n}\n\n.success {\n  background: #f0fdf4;\n  color: #16a34a;\n  padding: var(--space-4);\n  border-radius: var(--radius-lg);\n  border: 1px solid #bbf7d0;\n}\n\n/* ═══════════════════════════════════════════\n   ANNOUNCEMENT BAR — top trust strip\n   ═══════════════════════════════════════════ */\n.announcement-bar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 60;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 10px 16px;\n  background:\n    linear-gradient(90deg, rgba(110,232,149,0.14) 0%, rgba(170,140,255,0.18) 50%, rgba(110,232,149,0.14) 100%);\n  border-bottom: 1px solid rgba(170,140,255,0.2);\n  animation: announcementShimmer 12s ease-in-out infinite;\n  background-size: 200% 100%;\n  backdrop-filter: blur(16px);\n  -webkit-backdrop-filter: blur(16px);\n}\n\n/* Push the fixed header down below the announcement bar */\nbody.has-announcement header.fixed {\n  top: 42px;\n}\n@media (max-width: 640px) {\n  body.has-announcement header.fixed { top: 40px; }\n}\n@keyframes announcementShimmer {\n  0%, 100% { background-position: 0% 0%; }\n  50%      { background-position: 100% 0%; }\n}\n.announcement-bar-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  color: #ffffff;\n  text-decoration: none;\n  font-family: 'Montserrat', sans-serif;\n  font-size: 13px;\n  letter-spacing: 0.04em;\n  transition: opacity 0.2s ease;\n}\n.announcement-bar-link:hover { opacity: 0.85; }\n.announcement-bar-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #6ee895;\n  box-shadow: 0 0 12px rgba(110,232,149,0.9);\n  animation: announcementPulse 2s ease-in-out infinite;\n  flex-shrink: 0;\n}\n@keyframes announcementPulse {\n  0%, 100% { transform: scale(1); opacity: 1; }\n  50%      { transform: scale(1.25); opacity: 0.8; }\n}\n.announcement-bar-text {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n.announcement-bar-text strong {\n  font-weight: 600;\n  color: #ffffff;\n}\n.announcement-bar-sep {\n  color: rgba(255,255,255,0.35);\n}\n.announcement-bar-cta {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  color: #a98fff;\n  font-weight: 500;\n  transition: color 0.2s ease, transform 0.2s ease;\n}\n.announcement-bar-link:hover .announcement-bar-cta {\n  color: #ffffff;\n  transform: translateX(3px);\n}\n.announcement-bar-close {\n  position: absolute;\n  right: 14px;\n  top: 50%;\n  transform: translateY(-50%);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 26px;\n  height: 26px;\n  border-radius: 50%;\n  background: transparent;\n  border: 1px solid rgba(255,255,255,0.1);\n  color: rgba(255,255,255,0.55);\n  cursor: pointer;\n  transition: color 0.2s ease, border-color 0.2s ease, background 0.2s ease;\n}\n.announcement-bar-close:hover {\n  color: #ffffff;\n  border-color: rgba(255,255,255,0.3);\n  background: rgba(255,255,255,0.06);\n}\n@media (max-width: 640px) {\n  .announcement-bar { padding: 9px 40px 9px 14px; font-size: 12px; }\n  .announcement-bar-link { font-size: 12px; gap: 8px; }\n  .announcement-bar-close { right: 10px; width: 22px; height: 22px; }\n}\n\n/* ═══════════════════════════════════════════\n   FLOATING CONTACT — always-available action\n   ═══════════════════════════════════════════ */\n.floating-contact {\n  position: fixed;\n  bottom: 24px;\n  right: 24px;\n  z-index: 50;\n  opacity: 0;\n  transform: translateY(18px);\n  transition: opacity 0.3s ease, transform 0.3s ease;\n  pointer-events: none;\n}\n.floating-contact-visible {\n  opacity: 1;\n  transform: translateY(0);\n  pointer-events: auto;\n}\n\n.floating-main-btn {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 20px 12px 14px;\n  background: linear-gradient(135deg, #a98fff 0%, #7c5cff 100%);\n  border: 1px solid rgba(255,255,255,0.18);\n  border-radius: 999px;\n  color: #100D25;\n  font-family: 'Montserrat', sans-serif;\n  font-size: 13px;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  cursor: pointer;\n  box-shadow:\n    0 10px 30px rgba(140,90,240,0.45),\n    0 4px 10px rgba(0,0,0,0.2);\n  transition: transform 0.25s ease, box-shadow 0.25s ease;\n  z-index: 2;\n}\n.floating-main-btn:hover {\n  transform: translateY(-2px) scale(1.03);\n  box-shadow:\n    0 14px 40px rgba(170,140,255,0.55),\n    0 4px 10px rgba(0,0,0,0.2);\n}\n.floating-main-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n.floating-main-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: #14b85f;\n  box-shadow: 0 0 10px rgba(20,184,95,0.9);\n  animation: floatingDotPulse 2s ease-in-out infinite;\n}\n@keyframes floatingDotPulse {\n  0%, 100% { transform: scale(1); }\n  50%      { transform: scale(1.35); }\n}\n.floating-main-icon-close {\n  width: 18px;\n  height: 18px;\n  transition: opacity 0.25s ease, transform 0.25s ease;\n}\n.floating-main-icon-hidden {\n  opacity: 0;\n  transform: rotate(-90deg) scale(0.5);\n  width: 0;\n  margin: 0;\n}\n\n.floating-pulse-ring {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 100%;\n  height: 100%;\n  transform: translate(-50%, -50%);\n  border-radius: 999px;\n  border: 2px solid rgba(170,140,255,0.45);\n  animation: floatingPulseRing 2.6s ease-out infinite;\n  pointer-events: none;\n}\n@keyframes floatingPulseRing {\n  0%   { transform: translate(-50%, -50%) scale(1);    opacity: 0.7; }\n  100% { transform: translate(-50%, -50%) scale(1.45); opacity: 0; }\n}\n.floating-contact-expanded .floating-pulse-ring {\n  animation: none;\n  opacity: 0;\n}\n\n.floating-options {\n  position: absolute;\n  bottom: 58px;\n  right: 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  opacity: 0;\n  transform: translateY(10px);\n  pointer-events: none;\n  transition: opacity 0.3s ease, transform 0.3s ease;\n}\n.floating-options-show {\n  opacity: 1;\n  transform: translateY(0);\n  pointer-events: auto;\n}\n.floating-option {\n  width: 42px;\n  height: 42px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #ffffff;\n  background: rgba(20, 16, 46, 0.92);\n  border: 1px solid rgba(170,140,255,0.28);\n  border-radius: 50%;\n  text-decoration: none;\n  backdrop-filter: blur(12px);\n  box-shadow: 0 8px 24px rgba(0,0,0,0.35);\n  transition: transform 0.25s ease, background 0.25s ease, border-color 0.25s ease;\n}\n.floating-option:hover {\n  transform: scale(1.1);\n  background: rgba(170,140,255,0.18);\n  border-color: rgba(170,140,255,0.55);\n}\n.floating-option-whatsapp { color: #25D366; }\n.floating-option-calendar { color: #a98fff; }\n\n.floating-scroll-top {\n  position: fixed;\n  bottom: 26px;\n  left: 24px;\n  z-index: 50;\n  width: 42px;\n  height: 42px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(20, 16, 46, 0.8);\n  border: 1px solid rgba(170,140,255,0.28);\n  border-radius: 50%;\n  color: rgba(255,255,255,0.75);\n  cursor: pointer;\n  backdrop-filter: blur(12px);\n  opacity: 0;\n  transform: translateY(14px);\n  transition: opacity 0.3s ease, transform 0.3s ease, color 0.2s ease, border-color 0.2s ease, background 0.2s ease;\n  pointer-events: none;\n}\n.floating-scroll-top-visible {\n  opacity: 1;\n  transform: translateY(0);\n  pointer-events: auto;\n}\n.floating-scroll-top:hover {\n  color: #a98fff;\n  border-color: rgba(170,140,255,0.55);\n  background: rgba(170,140,255,0.14);\n}\n\n@media (max-width: 640px) {\n  .floating-contact { bottom: 16px; right: 16px; }\n  .floating-main-btn { padding: 10px 16px 10px 12px; font-size: 12px; }\n  .floating-scroll-top { bottom: 16px; left: 16px; width: 38px; height: 38px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
